import { styled } from '@/styled-system/jsx';

import { HR } from '@zillow/zrs-comet';

export const StyledHR = styled(HR, {
  base: {
    opacity: 'disabled',
    flexBasis: 'initial',
    marginBlock: '600',
    marginInline: '0',
  },
});
